'use strict'
types           = new ( require 'intertype' ).Intertype()
types.defaults  = {}
module.exports  = types
